import { jsxs, jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Image as Image$1 } from "@zillow/constellation-10";
import { withPreload, Figure } from "@zillow/zrs-cms";
import React from "react";
import { pickAnimationDomProps } from "../../components/BlockAnimation/animationConfig.esm.js";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import StructuredData from "../../components/StructuredData/StructuredData.esm.js";
import { withAnchor } from "../../util/helpers.esm.js";
const blockImageStyles = css.raw({
  // The v8 Image rendered as a default inline <img>, so editors centered
  // images through an ancestor's text-align (e.g. Card/Group textAlign). The
  // v10 Image forces display: block, which flushes narrower-than-container
  // images left. The doubled :is(img) outranks v10's `.class:is(img)` rule
  // (0,1,2 vs 0,1,1) without depending on stylesheet order. Sizing
  // (max-width: 100%, height: auto) comes from the app's globalCss img reset,
  // matching v8.
  "&:is(img):is(img)": {
    display: "inline"
  }
});
const ImagePreload = withPreload(Image$1);
const BlockImage = ({
  attrs,
  index
}) => {
  const {
    alt,
    caption,
    src,
    width,
    height,
    loading = "lazy",
    decoding = "async",
    sizes,
    srcSet,
    margin
  } = attrs;
  const structuredData = {
    "@context": "https://schema.org/",
    "@type": "ImageObject",
    contentUrl: src,
    caption: alt,
    height,
    width
  };
  const isPost = usePlacement() === "post";
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(StructuredData, { data: structuredData }),
    /* @__PURE__ */ jsxs(Figure, { ...isPost ? {
      marginBottom: "md"
    } : margin, ...pickAnimationDomProps(attrs), children: [
      /* @__PURE__ */ jsx(
        ImagePreload,
        {
          src,
          alt,
          width,
          height,
          loading,
          decoding,
          srcSet,
          sizes,
          css: blockImageStyles
        },
        index
      ),
      caption && /* @__PURE__ */ jsx(Figure.Caption, { children: caption })
    ] })
  ] });
};
const Image = withAnchor(BlockImage);
export {
  Image as default
};
